export default __webpack_public_path__ + "8780d66ef2d651460be20bd5afb0d622.png";